import { useState } from 'react';
import './Loader.css';
import gif from './logo.png';


export interface ILoaderProps
{
    Title : string,
    Message: string    
}

export class LoaderDialog
{
    private static _showLoaderFunction? : (props? : ILoaderProps) => void;
    private static _closeLoader? : ()=>void;

    public static Show(texts: ILoaderProps)
    {
        if(LoaderDialog._showLoaderFunction)
            LoaderDialog._showLoaderFunction(texts);
    }

    public static Close()
    {
        if(LoaderDialog._closeLoader)
            LoaderDialog._closeLoader();
    }
}

export default function Loader()
{
    let [visible, setVisibility] = useState(false);
    let [texts, setTexts] = useState<ILoaderProps>({Title: "Aguarde", Message: "Carregando dados"});
    
    LoaderDialog["_showLoaderFunction"] = (s) => 
    {
        if(s)
            setTexts(s);

        setVisibility(true);
    };

    LoaderDialog["_closeLoader"] = () => setVisibility(false);

    return(
        <div className="LoaderContainer" style={visible ? {display: 'flex'} : {display: 'none'}}>
            <div className="LoaderComponent">
                <h1>{texts.Title}</h1>
                <img src={gif} className='Spinner' />
                <h4>{texts.Message}</h4>
            </div>
        </div>
    )
}